import { UserRole } from "@src/types/auth.types";

export const getAuthUrl = (environment?: string) => {
  if (process.env.NODE_ENV === "development") return "http://localhost:3000";

  switch (environment) {
    case "development":
      return "http://localhost:3000";
    case "beta":
      return "https://timeedit.dev";
    case "staging":
      return "https://timeedit.io";
    case "test":
      return "https://test.timeedit.net";
    default:
      return "https://timeedit.net";
  }
};

export function getIsAdmin(scopes: UserRole[]) {
  return scopes.some((scope) =>
    [UserRole.ADMIN, UserRole.SYSTEM_ADMIN].includes(scope)
  );
}
